import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [statuses, setStatuses] = useState(['PUBLISHED', 'DRAFT']);
  const [keyword, setKeyword] = useState('');

  const handleCheck = (val) => {
    const existingIndex = statuses.findIndex((item) => item === val);
    const newArray = [...statuses];
    if (existingIndex >= 0) {
      newArray.splice(existingIndex, 1);
      setStatuses(newArray);
    } else {
      newArray.push(val);
      setStatuses(newArray);
    }
  };

  const filterData = () => {
    onFilter(statuses, keyword);
    document.getElementById('closeModal').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Nama Paket</label>
              <input
                type="text"
                onChange={(e) => setKeyword(e.target.value)}
                className="form-control"
                value={keyword}
              />
            </div>
            <label htmlFor="checkboxes" className="fw-600 mb-10">
              Status :
            </label>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('PUBLISHED')}
                checked={statuses.includes('PUBLISHED')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Published</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('DRAFT')}
                checked={statuses.includes('DRAFT')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Draft</div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
